export default __webpack_public_path__ + "static/nav-banner-car@2x-d5c5202733073e1829ad1e5764a043e7.png";